<template>
  <div class="form-slider">
    <div
      v-if="valuePosition === 'top'"
      class="form-slider__value"
      :style="{
        '--clr': valueColor,
      }"
    >
      <slot name="value">
        {{ valueLabel }}
      </slot>
    </div>
    <div class="form-slider__container">
      <div class="form-slider__left">
        <div class="form-slider__control">
          <vue-slider
            :value="value"
            dot-size="9"
            tooltip="none"
            :duration="0.15"
            v-bind="$attrs"
            @change="onChange"
          />
        </div>
        <div class="form-slider__labels">
          <label
            v-if="$slots['left-label']"
            class="form-slider__label"
          >
            <slot name="left-label" />
          </label>
          <label
            v-if="$slots['right-label']"
            class="form-slider__label"
          >
            <slot name="right-label" />
          </label>
        </div>
      </div>
      <div
        v-if="$attrs.max || valuePosition === 'right'"
        class="form-slider__right"
      >
        <template v-if="valuePosition !== 'right'">
          {{ maxLabel }}
        </template>
        <template v-else>
          {{ valueLabel }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-slider',
  props: {
    value: {
      type: [String, Number, Array],
      required: true,
    },
    valueColor: {
      type: String,
      default: '#3ff09f',
    },
    valuePosition: {
      type: String,
      default: 'top',
      validator(value) {
        return ['top', 'right', 'none'].indexOf(value) !== -1;
      },
    },
    units: {
      type: String,
      default: 'mi',
    },
    unitsPosition: {
      type: String,
      default: 'post',
    },
  },
  computed: {
    valueLabel() {
      if (Array.isArray(this.value)) {
        return this.value
          .map(
            item =>
              `${this.unitsPosition === 'pre' ? this.units : ''}${item}${
                this.unitsPosition === 'post' ? this.units : ''
              }`,
          )
          .join('-');
      }
      return `${this.unitsPosition === 'pre' ? this.units : ''}${this.value}${
        this.unitsPosition === 'post' ? this.units : ''
      }`;
    },
    maxLabel() {
      return `${this.unitsPosition === 'pre' ? this.units : ''}${
        this.$attrs.max
      }${this.unitsPosition === 'post' ? this.units : ''}`;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-slider {
  &__value {
    font-size: 13px;
    line-height: 20px;
    font-weight: bold;
    color: #8fb6f5;
    color: var(--clr, #8fb6f5);
    & + * {margin-top: 10px;}
  }
  &__container {
    display: flex;
  }
  &__left {
    flex-grow: 1;
  }
  &__labels {
    display: flex;
    justify-content: space-between;
    font-size: 9px;
    line-height: 19px;
    text-transform: uppercase;
    color: #a7a7c6;
  }
  &__right {
    padding-left: 9px;
    text-align: right;
    font-size: 10px;
    font-weight: bold;
    min-width: 33px;
    line-height: 13px;
    color: #8fb6f5;
  }
}
</style>

<style>
.vue-slider-process {
  background-color: #8fb6f5;
  border-radius: 0;
}
.vue-slider-dot-handle {
  box-shadow: none;
}
.vue-slider-rail {
  background-color: #27274f;
  border-radius: 0;
}
</style>
